import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const languages = ["English", "한국어", "中文"];

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#EDEEF3]">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-60 -right-60 w-[900px] h-[900px] rounded-full border border-[#1E202A]/[0.03]" />
        <div className="absolute -top-32 -right-32 w-[680px] h-[680px] rounded-full border border-[#1E202A]/[0.03]" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-[#D2D4DE]/60" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-36 pb-28">
        {/* Brand mark */}
        <div className="mb-2 mt-16 text-center">
          <span
            className="text-[#1E202A] leading-none block"
            style={{ fontFamily: "'Great Vibes', cursive", fontSize: "clamp(52px, 7vw, 88px)" }}
          >
            Wills &amp; Trusts
          </span>
        </div>

        {/* Firm name — gold */}
        <div className="mb-3 text-center">
          <p
            className="leading-none uppercase"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(11px, 1.3vw, 15px)", fontWeight: 600, color: "#B8942A", letterSpacing: "0.22em" }}
          >
            {t("brand.firmName")}
          </p>
        </div>

        {/* Motto */}
        <p
          className="text-[#A8AABB] mb-10 leading-snug text-center"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(12px, 1.2vw, 14px)", fontWeight: 400, letterSpacing: "0.05em" }}
        >
          {t("brand.motto")}
        </p>

        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-px bg-[#8A7A6A]/40 mb-8" />

          <h1
            className="text-[#1E202A] leading-tight mb-5"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(38px, 5vw, 68px)", fontWeight: 300, letterSpacing: "-0.01em" }}
          >
            {t("hero.h1Line1")}
            <br />
            <em>{t("hero.h1Line2")}</em>
          </h1>

          <p className="text-[#74758A] text-sm leading-[2] mb-4 max-w-lg">{t("hero.desc1")}</p>
          <p className="text-[#74758A] text-sm leading-[2] mb-10 max-w-lg">{t("hero.desc2")}</p>

          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#1E202A] text-[#EDEEF3] px-9 py-4 rounded-full text-sm font-medium hover:bg-[#8A7A6A] transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ letterSpacing: "0.03em" }}
            >
              {t("hero.cta1")}
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 border border-[#D2D4DE] text-[#1E202A] px-9 py-4 rounded-full text-sm font-medium hover:border-[#8A7A6A] hover:text-[#8A7A6A] transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ letterSpacing: "0.03em" }}
            >
              {t("hero.cta2")}
            </Link>
          </div>
        </div>

        {/* Bottom accent */}
        <div className="mt-24 flex flex-col items-center gap-3">
          <div className="w-px h-10 bg-[#D2D4DE]" />
          <div className="flex flex-col items-center gap-1.5">
            <p className="text-[#74758A]/60 text-xs leading-relaxed tracking-wide">{t("hero.note")}</p>
            <div className="flex items-center gap-3">
              {languages.map((lang, i) => (
                <span key={lang} className="flex items-center gap-3">
                  <span className="text-[#A8AABB] text-[11px] tracking-widest uppercase">{lang}</span>
                  {i < languages.length - 1 && <span className="text-[#D2D4DE] text-[11px]">·</span>}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
